import { FunctionComponent } from 'react';

type SkillsGridProps = {
  skills: string;
};

const SkillsGrid: FunctionComponent<SkillsGridProps> = ({ skills }) => {
  if (!skills || skills.length === 0) return <></>;

  const skillsArray = skills.split(',');

  return (
    <>
      <div>
        {skillsArray.map((skill: string) => {
          return (
            <span
              key={skill}
              className="inline-flex items-center px-2.5 py-0.5 m-1 rounded-sm text-sm text-friendly-pink border border-friendly-pink"
            >
              {skill}
            </span>
          );
        })}
      </div>
    </>
  );
};

export default SkillsGrid;
